import React from "react";
import PostCard from "./PostCard";
import axios from "../../../config/axiosConfig";
import CircularProgress from "@mui/material/CircularProgress";
export const NewFeed = () => {
  const [posts, setPosts] = React.useState(null);
  React.useEffect(() => {
    const getPosts = async () => {
      try {
        const response = await axios.get("/post", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        if (response.data.status === "success") {
          setPosts(response.data.data);
          localStorage.setItem("posts", JSON.stringify(response.data.data));
        }
      } catch (error) {
        console.log(error);
      }
    };
    getPosts();
  }, []);
  return (
    <>
      {posts ? (
        posts.map((post) => {
          return <PostCard post={post} />;
        })
      ) : (
        <div className="flex justify-center items-center h-[80vh]">
          <CircularProgress
            sx={{
              color: "#FF000F",
            }}
          />
        </div>
      )}
    </>
  );
};
